import React from 'react';

import ErrorIconSVG from './ErrorIconSVG';
import WarningIconSVG from './WarningIconSVG';

// ─── TitleIcon component ──────────────────────────────────────────────────────

/**
 * Renders an icon next to the dialog title for 'danger' or 'warning' appearance.
 * Replaces the Atlaskit TitleIcon. All styling via CSS classes in _custom_dialog.scss.
 *
 * @param {Object} props - Component props.
 * @param {string} [props.appearance] - 'danger' | 'warning'.
 * @returns {ReactElement|null}
 */
const TitleIcon = ({ appearance }: { appearance?: 'danger' | 'warning' }) => {
    if (!appearance) {
        return null;
    }

    const IconSymbol = appearance === 'danger' ? ErrorIconSVG : WarningIconSVG;

    return (
        <span className = { `custom-title-icon custom-title-icon--${appearance}` }>
            <IconSymbol label = { `${appearance} icon` } />
        </span>
    );
};

export default TitleIcon;
